import { Slider } from 'components/swiper'
import { Container } from 'components/container'
import { Section, Title } from '../styled'
import PlaceholderImage from './assets/no-photo.svg'
import { Image, Slide } from './styled'

const slides = [
  {
    image: require('./assets/01000000-c0a8-0242-4e87-08dcc82e76c4_w500.png'),
    title: 'Соня Шац',
    description: 'певица и подкастерка, талантливая ведущая',
  },
  {
    image: require('./assets/01000000-0a00-0242-5e17-08dcc82e76cb_w500.png'),
    title: 'Эдуард Мацаберидзе',
    description: ' украинский телеведущий, шоумен и комедийный актёр.',
  },
  {
    image: require('./assets/01000000-0a00-0242-63b4-08dcc82e8278_w500.png'),
    title: 'Василь Байдак',
    description: 'Стендап-комик',
  },
  {
    image: require('./assets/01000000-0a00-0242-d2af-08dcc82e76c2_w500.png'),
    title: 'Маха Горячева',
    description: 'Видеоблогер и певица',
  },
  {
    image: require('./assets/01000000-0a00-0242-aa04-08dcc82e827c_w500.png'),
    title: 'Мишель Андраде',
    description: 'Певица и телеведущая из Боливии',
  },
  {
    image: require('./assets/01000000-0a00-0242-9459-08dcc82e76c0_w500.png'),
    title: 'Кирилл Макашов',
    description: 'Специалист по языкам',
  },
]

export const Casting = () => {
  return (
    <Section id="cast">
      <Container>
        <Title>Ведущие</Title>
        <Slider
          titleInNav
          slides={slides.map(s => ({
            ...s,
            description: <p>{s.description}</p>,
            component: (
              <Slide>
                <Image src={s.image ?? PlaceholderImage} alt={s.title} />
              </Slide>
            ),
          }))}
        />
      </Container>
    </Section>
  )
}
